import type { people360 as en } from "../en/people360";
import type { Messages } from "../types";

export const people360: Messages<typeof en> = {
  title: "شخص",
  back: "العودة إلى الأشخاص",
  likesLimit: "إنستغرام لا يشارك من أعجب بالمنشور",
  likesLimitHint: "تُحسب الإعجابات لكل منشور، لكن إنستغرام لا يكشف من أعجب به، لذلك لا تظهر في سجل الشخص.",
  openOnInstagram: "فتح على إنستغرام",
  openProfile: "فتح الملف الكامل",
  openPerson: "فتح {{name}}",
  notFound: "لم يتم العثور على هذا الشخص",
  unknownName: "مستخدم إنستغرام",
  followers: "{{n}} متابع",
  header: {
    firstSeen: "أول ظهور {{when}}",
    lastSeen: "آخر ظهور {{when}}",
    mark: "التصنيف",
    tags: "الوسوم",
    noTags: "لا وسوم بعد",
  },
  stats: {
    title: "نظرة سريعة",
    comments: "التعليقات",
    dms: "الرسائل",
    replyRate: "نسبة الرد",
    responseTime: "متوسط زمن الرد",
    none: "—",
    sentiment: "المشاعر أسبوعياً",
    sentimentLabel: "أسبوع {{week}}: {{positive}} إيجابي، {{neutral}} محايد، {{negative}} سلبي",
    noSentiment: "لا توجد مشاعر بعد",
    accounts: "الحسابات التي يتواصل معها",
    posts: "المنشورات التي علّق عليها",
    postCount: "{{n}} تعليقات",
    interactions: "التفاعلات: {{n}}",
  },
  timeline: {
    title: "السجل",
    description: "كل تعليق ورسالة ورد ومسودة ذكاء اصطناعي وتشغيل قاعدة وملاحظة فريق — الأحدث أولاً.",
    empty: "لا شيء هنا بعد",
    emptyFiltered: "لا شيء يطابق هذه التصفية",
    loadingMore: "جارٍ تحميل المزيد…",
    end: "هذا كل شيء",
    filters: "فلاتر السجل",
    allAccounts: "كل الحسابات",
    allPosts: "كل المنشورات",
    account: "الحساب",
    post: "المنشور",
    open: "فتح",
    onPost: "على منشور",
    groups: { today: "اليوم", yesterday: "أمس", week: "هذا الأسبوع", earlier: "أقدم" },
    chips: { all: "الكل", comments: "التعليقات", dms: "الرسائل", automation: "الأتمتة", team: "الفريق" },
    types: {
      comment: "علّق",
      reply: "رددنا",
      dm_in: "أرسل رسالة",
      dm_out: "أرسلنا رسالة",
      reaction: "تفاعل مع رسالة",
      story_reply: "ردّ على قصة",
      mention: "أشار إلى الحساب",
      ai_draft: "صاغ الذكاء الاصطناعي رداً",
      approval: "موافقة",
      automation_run: "تم تشغيل قاعدة",
      flag: "أُضيف وسم",
      mark: "تم التصنيف",
      note: "ملاحظة الفريق",
      enrichment: "تم جلب الملف العام",
    },
    states: { hidden: "مخفي", deleted: "محذوف", archived: "مؤرشف", pinned: "مثبّت", edited: "معدّل" },
    outcome: "النتيجة: {{status}}",
    actors: { ai: "الذكاء الاصطناعي", automation: "الأتمتة", user: "الفريق", system: "ملفك", account: "الحساب" },
    by: "بواسطة {{name}}",
  },
  notes: {
    title: "الملاحظات",
    placeholder: "أضف ملاحظة للفريق…",
    add: "إضافة ملاحظة",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل الملاحظة",
    delete: "حذف الملاحظة",
    deleteConfirm: "حذف هذه الملاحظة؟",
    empty: "لا ملاحظات بعد",
    readOnly: "يمكن للمشاهدين قراءة الملاحظات دون تعديلها.",
    saved: "تم حفظ الملاحظة",
    deleted: "تم حذف الملاحظة",
  },
  search: {
    section: "الأشخاص",
    placeholder: "ابحث عن الأشخاص باسم المستخدم أو الاسم",
    keyword: "قال «\u2068{{snippet}}\u2069»",
    none: "لا أشخاص مطابقون",
    searching: "جارٍ البحث…",
    results: "نتائج الأشخاص",
  },
};
